import useEffectOnce from './useEffectOnce';

export default (callback) => {
  useEffectOnce(() => callback);
};
